import React from 'react';

function ReceiptUser({ userDetails, paymentDetails }) {
    return (
        <>
            <div className="row">
                <div className="col-md-6">
                    <div className="coustomer-detail">
                        <h3 className='mb-3'>User Details:</h3>
                        <ul>
                            <li><strong>Name:</strong> <span className="gray-clr">{userDetails.name}</span></li>
                            <li><strong>Email:</strong> <span className="gray-clr">{userDetails.email}</span></li>
                            <li><strong>Booking Count:</strong> <span className="gray-clr">{userDetails.count}</span></li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="payment-detail">
                        <h3 className='mb-3'>Payment Details:</h3>
                        <ul>
                            <li><strong>Recevied Amount:</strong> <span className="gray-clr">{paymentDetails.recpay}</span></li>
                            <li><strong>Total Amount:</strong> <span className="gray-clr">{paymentDetails.total}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReceiptUser;
